import axiosClient from './axiosClient';

const alarmController = {
  clearAlarm(token, alarmId) {
    const url = `/api/alarm/${alarmId}/clear`;
    const payload = {};
    return axiosClient.post(url, payload, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
  getAlarms(token, entityType, entityId, page = 0, pageSize = 10) {
    const url = `/api/alarm/${entityType}/${entityId}?page=${page}&pageSize=${pageSize}&sortProperty=endTs&sortOrder=DESC`;
    return axiosClient.get(url, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
};

export default alarmController;
